module.exports = window["core-js/modules/es.regexp.constructor.js"];